import React from 'react';
import { Pagination } from 'react-admin';

const BoxitPagination = (props: any) => {
    const {
        onChangePage,
        onPageChange,
        onChangeRowsPerPage,
        onRowsPerPageChange,
        ...rest
    } = props;

    return (
        <Pagination
            rowsPerPageOptions={[10, 20, 50]}
            onPageChange={onPageChange || onChangePage}
            onRowsPerPageChange={
                onRowsPerPageChange || onChangeRowsPerPage
            }
            {...rest}
        />
    );
};

export default BoxitPagination;
